import { render } from "./update.vue?vue&type=template&id=4eb97eab"
import script from "./update.vue?vue&type=script&lang=js"
export * from "./update.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/appointments/update.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4eb97eab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4eb97eab', __exports__)) {
    console.log('reload')
    api.reload('4eb97eab', __exports__)
  }
  
  module.hot.accept("./update.vue?vue&type=template&id=4eb97eab", () => {
    console.log('re-render')
    api.rerender('4eb97eab', render)
  })

}


export default __exports__